<nav aria-label="Main Site Navigation" role="navigation" (focusout)="onNavFocusOut($event)">
  <!-- A single button that swaps its icon. Two buttons taking turns via display:none
       dropped focus the moment the menu opened, because the browser discards focus on
       an element that leaves the layout - so Tab restarted from the top of the document
       instead of moving into the menu that had just been opened. -->
  <button class="hamburger" (click)="toggleMenuHamburger()"
    aria-label="Toggle Hamburger Menu"
    [attr.aria-expanded]="hamburgerMenuDisplay">
    @if (hamburgerMenuDisplay) {
      <svg-icon-sprite [src]="'assets/sprite/sprite.svg#icon-hamburger-close'" [width]="'24px'" [height]="'24px'">
      </svg-icon-sprite>
    } @else {
      <svg-icon-sprite [src]="'assets/sprite/sprite.svg#icon-hamburger'" [width]="'40px'" [height]="'24px'">
      </svg-icon-sprite>
    }
  </button>
  <ul class="reset" [ngClass]="{'visible' : hamburgerMenuDisplay}">
    <li>
      <span class="tooltip-wrapper">
        <a id="faw"
        href="https://www.fracfocus.org/wells/advanced" (click)="hamburgerMenuDisplay = false; openLink($event, 'https://www.fracfocus.org/wells/advanced')">Find a Well</a>
        <app-popper-tool-tip [popperPlacementParam]="mainNavPopperPlacement" screenReaderText="Search for a Submitted Disclosure">
        </app-popper-tool-tip>
      </span>
    </li>
    <li>
      <span class="tooltip-wrapper">
        <a id="about" (click)="hamburgerMenuDisplay = false"
        routerLink="/about">About</a>
        <app-popper-tool-tip [popperPlacementParam]="mainNavPopperPlacement" screenReaderText="View about the FracFocus chemical disclosure registry">
        </app-popper-tool-tip>
      </span>
    </li>
    @if (userInfo && userInfo.userName && currentOrg) {
      <li>
        <span class="tooltip-wrapper">
          <a id="dashboard" (click)="hamburgerMenuDisplay = false"
          routerLink="/dashboard">Dashboard</a>
          <app-popper-tool-tip [popperPlacementParam]="mainNavPopperPlacement" screenReaderText="Return to Dashboard">
          </app-popper-tool-tip>
        </span>
      </li>
    }
    @if (userInfo && userInfo.userName && currentOrg) {
      <li appNavSubMenu #disclosuresMenu="appNavSubMenu">
        <button id="disclosures" class="has-submenu"
          [class.expanded]="disclosuresMenu.expanded" [attr.aria-expanded]="disclosuresMenu.expanded">
          Disclosures<span class="separator" aria-hidden="true">&vert;</span><span class="arrow" aria-hidden="true">&#9662;</span>
        </button>
        <ul class="reset" aria-label="Disclosures Options">
          @if (currentOrg && userInfo.hasOrgRole('DataSubmitter')) {
            <li><a (click)="hamburgerMenuDisplay = false" routerLink="/disclosure/edit-disclosure/new">Add/Upload New Disclosure</a></li>
          }
          @if (currentOrg && (userInfo.hasOrgRole('DataSubmitter') || userInfo.hasOrgRole('Supervisor'))) {
            <li><a (click)="hamburgerMenuDisplay = false" routerLink="/disclosure/manage-disclosures">Manage Disclosures</a></li>
          }
          @if (currentOrg) {
            <li><a (click)="hamburgerMenuDisplay = false" routerLink="/disclosure/third-party-purposes">3rd Party Chemicals</a></li>
          }
          @if (userInfo) {
            <li><a (click)="hamburgerMenuDisplay = false" routerLink="/disclosure/view-disclosures">Submitted Disclosures</a></li>
          }
        </ul>
      </li>
    }
    <li appNavSubMenu #organizationMenu="appNavSubMenu"
        *appCanaccess="{user: userInfo,
        permissions: [CommonRoles.ServiceSupervisor, CommonRoles.OperatorSupervisor, CommonRoles.RegisteredAgtSupervisor, CommonRoles.OperatorSubmitter]}">
      <button id="manageOrganizations" class="has-submenu"
        [class.expanded]="organizationMenu.expanded" [attr.aria-expanded]="organizationMenu.expanded">
        Manage Organization<span class="separator" aria-hidden="true">&vert;</span><span class="arrow" aria-hidden="true">&#9662;</span>
      </button>

      <ul class="reset" aria-label="Manage Organization Options">
        @if (currentOrg && (userInfo.hasOrgRole('Supervisor'))) {
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/profile">Manage Organization Profile</a></li>
        }
        @if (!currentOrg) {
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/registration">New Organization Registration</a></li>
        }
        @if (currentOrg && (userInfo.hasOrgRole('Supervisor'))) {
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/manage-users">Manage Organization Users</a></li>
        }
        <li *appCanaccess="{user: userInfo, permissions: [CommonRoles.OperatorSupervisor]}"><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/manage-org-relations">Manage Organization Relations</a></li>
        @if (currentOrg && currentOrg.isOperator && !userInfo.hasOrgRole('Supervisor') && userInfo.hasOrgRole('DataSubmitter')) {
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/manage-org-relations">View Organization Relations</a></li>
        }
        @if (currentOrg && userInfo.hasOrgRole('Supervisor')) {
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/organization-defaults">Manage Organization Defaults</a></li>
        }
        <li *appCanaccess="{user: userInfo, permissions: [CommonRoles.ServiceSupervisor, CommonRoles.RegisteredAgtSupervisor]}"><a (click)="hamburgerMenuDisplay = false" routerLink="/organization/operator-approvals">Operator Approvals</a></li>
        <!--<li><a href="#">View Service Companies</a></li>-->
      </ul>
    </li>

    <li *appCanaccess="{user: userInfo, permissions: [CommonRoles.ServiceUser, CommonRoles.RegisteredAgtUser], hiddenFromPermissions: [CommonRoles.ServiceSupervisor, CommonRoles.RegisteredAgtSupervisor]}">
      <a (click)="hamburgerMenuDisplay = false" id="operator-approvals" href="/organization/operator-approvals">
        Operator Approvals
      </a>
    </li>
    <li appNavSubMenu #userGuidesMenu="appNavSubMenu">
      <button id="userGuides" class="has-submenu"
        [class.expanded]="userGuidesMenu.expanded" [attr.aria-expanded]="userGuidesMenu.expanded">
        User Guides<span class="separator" aria-hidden="true">&vert;</span><span class="arrow" aria-hidden="true">&#9662;</span>
      </button>

      <ul class="reset" aria-label="User Guides Options">
        @if (userInfo && userInfo.userName) {
          <li><a href="/assets/FracFocus_Schema_Requirements.pdf" (click)="hamburgerMenuDisplay = false; openLink($event, '/assets/FracFocus_Schema_Requirements.pdf')">Schema Guide</a></li>
        }
        <li><a href="/assets/FracFocus_User_Guide_V1.pdf" (click)="hamburgerMenuDisplay = false; openLink($event, '/assets/FracFocus_User_Guide_V1.pdf')">User Guide</a></li>
        @if (userInfo && userInfo.isAdmin) {
          <li><a href="/assets/FracFocus_Admin_Guide_V1.pdf" (click)="hamburgerMenuDisplay = false; openLink($event, '/assets/FracFocus_Admin_Guide_V1.pdf')">Admin Guide</a></li>
        }
        <li><a (click)="hamburgerMenuDisplay = false" routerLink="/accessibility-statement">Accessibility Statement</a></li>
      </ul>

    </li>
    @if (userInfo && userInfo.userName && userInfo.isAdmin) {
      <li appNavSubMenu #administrationMenu="appNavSubMenu">
        <button id="administration" class="has-submenu"
          [class.expanded]="administrationMenu.expanded" [attr.aria-expanded]="administrationMenu.expanded">
          Administration<span class="separator" aria-hidden="true">&vert;</span><span class="arrow" aria-hidden="true">&#9662;</span>
        </button>
        <ul class="reset" aria-label="Administration Options">
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/system-logs">System Logs</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/disclosure-admin">Manage/Remove Disclosures</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/users">Manage Accounts</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/registrations">Manage Registrations</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/organization-stats">Organization Stats</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/ingredients">Manage Ingredients</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/notifications">Manage Notifications</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/global-defaults">System Configuration Settings</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" routerLink="/administration/reports">Reports</a></li>
          <li><a (click)="hamburgerMenuDisplay = false" href="/hangfire">Hangfire Dashboard</a></li>
        </ul>
      </li>
    }
    @if (userInfo && userInfo.userName && availableReports && availableReports.length) {
      <li appNavSubMenu #reportsMenu="appNavSubMenu">
        <button id="reports" class="has-submenu"
          [class.expanded]="reportsMenu.expanded" [attr.aria-expanded]="reportsMenu.expanded">
          Reports<span class="separator" aria-hidden="true">&vert;</span><span class="arrow" aria-hidden="true">&#9662;</span>
        </button>
        <ul class="reset" aria-label="Reports">
          @for (r of availableReports; track r) {
            <li><a [routerLink]="['/organization-reports/reports/operator/',r.storedProcedure]">{{r.reportName}}</a></li>
          }
          @for (r of adminReports; track r) {
            <li><a [routerLink]="['/organization-reports/reports/operator/',r.storedProcedure]">{{r.reportName}}</a></li>
          }
        </ul>
      </li>
    }
    <li>
      <div class="user-info-container">
        <ui-user-info></ui-user-info>
      </div>
    </li>
  </ul>
</nav>
